import { Component, View, OnInit } from 'angular2/core';
import { CORE_DIRECTIVES, DatePipe} from 'angular2/common';
import { ROUTER_DIRECTIVES, Router } from 'angular2/router';

import { Header } from '../layout/header/header';
import { Sidebar } from '../layout/sidebar/sidebar';
import { Event } from './event.model';
import { EventService } from './event.service';
import { AlertService, AlertMessage, MessageType } from '../alert/alert.service';
import { SearchPipe } from '../search/search-pipe';
import { SearchBox } from '../search/search-box';
import { PaginatePipe } from '../pagination/paginate-pipe';
import { PaginationService } from '../pagination/pagination-service';
import { PaginationCmp } from '../pagination/pagination';

let template = require('./event-list.html');

@Component({
  selector: 'event-list',
  providers: [PaginationService]
})
@View({
  template: template,
  pipes: [DatePipe, SearchPipe, PaginatePipe],
  directives: [CORE_DIRECTIVES, ROUTER_DIRECTIVES, Header, Sidebar, SearchBox, PaginationCmp],
})
export class EventList implements OnInit {

  events: Event[] = [];

  constructor(
    public router: Router,
    public eventService: EventService,
    private alertService: AlertService) { }

  ngOnInit() {
    this.loadEvents();
  }

  loadEvents() {
    this.eventService.list().subscribe(response => {
      let events = [];
      for (let event of response.json()) {
        events.push(Event.fromJSON(event));
      }
      this.events = events;
    }, error => {
      this.alert('Error al recuperar el listado de eventos', MessageType.Danger);
    });
  }

  edit($event, event) {
    this.router.navigate(['/EventDetail', { id: event.id }]);
  }

  view($event, event) {
    this.router.navigate(['/EventView', { id: event.id }]);
  }

  delete($event, event) {
    let fn = () => {
      this.eventService.delete(event).subscribe(
        response => this.alert('Evento borrado con éxito', MessageType.Success),
        error => this.alert('Error al borrar el evento', MessageType.Danger)
      );
      this.router.renavigate();
    };
    this.confirm('¿Seguro que deseas borrar el evento ' + event.title + '?', fn);
  }

  add() {
    this.router.navigate(['EventNew']);
  }

  alert(text: string, type: MessageType) {
    this.alertService.push({ text, type });
  }

  confirm(message: string, callback) {
    let ok = confirm(message);
    if (ok) {
      callback();
    }
  }
}



/** WEBPACK FOOTER **
 ** ./~/tslint-loader!./src/event/event-list.ts
 **/